import React, { useEffect, useRef } from "react";
import { useDimensions } from "../../../../Logic/Dimensions";
import Icon from "../../../Layouts/Icons";
import Style from "./DashboardActiveProjects.module.scss";
import Assets from "../../../Layouts/Assets";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import ProjectCard from "../../ProjectCard";
import InfiniteDotLoader from "../../../../utils/InfiniteDotLoader";
import BlankDataPlaceholder from "../../BlankDataPlaceholder";
import useProjects from "../../../../Logic/useProjects";
import { getAllProjectsAPI } from "../../../../store/slices/Project/ProjectSlice";
import { Link } from "react-router-dom";

const DashboardActiveProjects = ({ className }) => {
  const imgRootRef = useRef(null);
  const dispatch = useDispatch();
  const windowDimensions = useDimensions();
  const { sections, currentTab, viewProjectDetails, status } = useSelector(
    (state) => state.project
  );
  const { isDataLoading } = useProjects();

  useEffect(() => {
    let obj = {
      url: "list-project",
      page: "1",
      sort: "desc",
      per_page: 20,
    };
    dispatch(getAllProjectsAPI(obj));
  }, []);

  return (
    <>
      <div
        className={`${Style.DashboardActiveProjects__container} ${className}`}
      >
        <div className={Style.DashboardActiveProjects__titlebar}>
          <div className={`row mb-3`}>
            <div className={`col-10 col-sm-9 my-auto`}>
              <h4 className={`mb-0 ${Style.DashboardActiveProjects__title}`}>
                Active Projects
              </h4>
            </div>
          </div>
        </div>

        <div className={Style.DashboardActiveProjects__wrap} ref={imgRootRef}>
          <div className={Style.DashboardActiveProjects}>
            {sections["activeTab"]?.data?.length === 0 ? (
              <div className={Style.DashboardActiveProjects__contents_no_staff}>
                <div>
                  <figure className="mb-0 ratio">
                    <img src={Assets.blank_folder_placeholder} alt="" />
                  </figure>
                  <h3 className={`${Style.no_staff__title} text-center`}>
                    No active projects
                  </h3>
                  <div className="text-center">
                    <Link
                      to="project"
                      className={`btn btn-border-primary mx-auto my-2 ${Style.DashboardActiveProjects__addStaff}`}
                    >
                      <Icon
                        color={"currentColor"}
                        size={16}
                        icon={"icon-plus"}
                        className={`${
                          windowDimensions.width >= 768 ? "me-2" : ""
                        }`}
                      />
                      {windowDimensions.width >= 768 ? "Add project" : ""}
                    </Link>
                  </div>
                </div>
              </div>
            ) : (
              <Row>
                {sections["activeTab"]?.data?.length > 0 ? (
                  <>
                    {sections["activeTab"]?.data
                      .slice(
                        0,
                        windowDimensions?.width >= 1920
                          ? 6
                          : windowDimensions?.width >= 1600
                          ? 5
                          : windowDimensions?.width >= 992
                          ? 4
                          : 3
                      )
                      ?.map((data, index) => {
                        return (
                          <Col
                            key={data?.id}
                            className="img-loading-2-item"
                            lg={3}
                            md={4}
                            sm={6}
                          >
                            <Link to={`project/${data?.id}`}>
                              <ProjectCard
                                data={data}
                                itemKey={index}
                                outlineCard={true}
                                menuHide={true}
                                hideMenu={true}
                              />
                            </Link>
                          </Col>
                        );
                      })}
                  </>
                ) : isDataLoading() ? (
                  <>
                    <div className={`${Style.infinite_dot_loader_wrap}`}>
                      <InfiniteDotLoader type={"project"} />
                    </div>
                  </>
                ) : (
                  <>
                    {/* <BlankDataPlaceholder
                  title={getTabPlaceholderText(currentTab)?.title}
                  description={getTabPlaceholderText(currentTab)?.description}
                  buttonText={getTabPlaceholderText(currentTab)?.buttonText}
                  // template={getTabPlaceholderText(currentTab)?.template}
                  template={"folder"}
                  onClick={() => {
                    handleSetAddProjectStepOne(true);
                    handleSetAddProjectStepTwo(false);
                    handleShowAddProject(true);
                  }}
                /> */}
                  </>
                )}
              </Row>
            )}
          </div>
        </div>
        <div className="w-100 mx-auto pt-4 d-flex ">
          {sections["activeTab"]?.data?.length >= 4 && (
            <Link
              to="project"
              className={`${Style.dashboard_view_all_btn} btn btn-border-primary mx-auto my-2`}
            >
              View All
            </Link>
          )}
        </div>
      </div>
    </>
  );
};

export default DashboardActiveProjects;
